/**
 * undefined, 1 - mouse click, mobile device tap
 * 13 - keyboard enter code
 * 32 - keyboard space code
 * @type {Array}
 */
export const actionKeyCodes = [undefined, 1, 13, 32];
